import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePagination } from "../../shared/hooks/usePagination";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { TemplateAppendixService } from "./service";
import { Card, CardBody, Col } from "react-bootstrap";
import Select from "react-select";
import { CustomPagination } from "../../shared/components/CustomPagination";
import DeleteModal from "../../Common/DeleteModal";
import { ITemplateAppendix } from "../../shared/interfaces/templateAppendix/ITemplateAppendix";
const PER_PAGE_DEFAULT = 20;

const TemplateAppendixList = () => {
    const { t } = useTranslation();
    const [list, setList] = useState<ITemplateAppendix[] | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState<number | null>(null);
    const navigate = useNavigate();
    const {
        page,
        handlePages,
        pagination,
        totalPages,
        setTotalPages,
        changeFilterHandler,
        goToPreviousPage,
        goToNextPage,
    } = usePagination({
        perPage: PER_PAGE_DEFAULT,
    });
    const entriesPerPageOptions = [
        { label: "10", value: 10 },
        { label: "25", value: 25 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "200", value: 200 },
    ];
    const handleDeleteClick = (id: number) => {
        setTemplateToDelete(id);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        if (templateToDelete !== null) {
            try {
                await TemplateAppendixService.delete(templateToDelete);
                SuccessToast(t("templateAppendix.successDelete"));
                setShowDeleteModal(false);
                setTemplateToDelete(null);
                fetchData();
            } catch (error) {
                ErrorToast(error);
            }
        }
    };

    const fetchData = async () => {
        try {
            const response = await TemplateAppendixService.get(pagination);
            const data = response.data;
            setList(data);
            setTotalPages(response.totalPages);
        } catch (error) {
            ErrorToast(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [pagination]);

    return (
        <React.Fragment>
            <Col>
                <Card>
                    <CardBody>
                        <div className="text-end">
                            <button
                                className="btn btn-primary text-end"
                                onClick={() => navigate("/template-appendix/create")}
                            >
                                <i className="ti ti-plus f-18"></i> {t("templateAppendix.add")}
                            </button>
                        </div>

                        <div className="d-sm-flex align-items-center mb-3">
                            <ul className="list-inline me-auto my-1">
                                <li className="list-inline-item">
                                    <Select
                                        placeholder={t("job.entriesPerPage")}
                                        options={entriesPerPageOptions}
                                        onChange={(selected) =>
                                            changeFilterHandler(
                                                "perPage",
                                                selected?.value ?? PER_PAGE_DEFAULT,
                                            )
                                        }
                                        defaultValue={entriesPerPageOptions.find(
                                            (option) => option.value === PER_PAGE_DEFAULT,
                                        )}
                                        classNamePrefix="react-select"
                                    />
                                </li>
                                <span> {t("job.entriesPerPage")}</span>
                            </ul>
                            <ul className="list-inline ms-auto my-1 mt-3">
                                <li className="list-inline-item">
                                    <form>
                                        <input
                                            className="form-control"
                                            type="text"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                changeFilterHandler("term", e.target.value)
                                            }
                                        />
                                    </form>
                                </li>
                            </ul>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover" id="pc-dt-simple-1">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>{t("general.name")}</th>
                                        <th>{t("general.updatedAt")}</th>
                                        <th className="text-end">{t("job.actions")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list?.map((item: any) => (
                                        <tr key={item?.id}>
                                            <td>{item?.id}</td>
                                            <td>{item?.name}</td>
                                            <td>
                                                {new Date(item.updatedAt).toLocaleDateString()}
                                            </td>{" "}
                                            <td className="text-end">
                                                <ul className="list-inline mb-0">
                                                    <li
                                                        className="list-inline-item"
                                                        onClick={() =>
                                                            navigate(`/template-appendix/edit/${item.id}`)
                                                        }
                                                    >
                                                        <a
                                                            href="#"
                                                            className="avtar avtar-s btn-link-success btn-pc-default"
                                                        >
                                                            <i className="ti ti-edit f-20"></i>
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <span
                                                            role="button"
                                                            className="avtar avtar-s btn-link-danger btn-pc-default"
                                                            onClick={() => handleDeleteClick(item.id)}
                                                        >
                                                            <i className="ti ti-trash f-20"></i>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <CustomPagination
                            page={page}
                            totalPages={totalPages}
                            handlePages={handlePages}
                            goToPreviousPage={goToPreviousPage}
                            goToNextPage={goToNextPage}
                        />
                    </CardBody>
                </Card>
            </Col>

            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleDeleteId={handleDeleteConfirm}
                name={templateToDelete}
            />
        </React.Fragment>
    );
};

export default TemplateAppendixList;
